// extracted by mini-css-extract-plugin
export var cardTitle = "_i1-1";
export var commentBubble = "_i1-e";
export var commentForm = "_i1-a";
export var commentInput = "_i1-b";
export var commentLabel = "_i1-d";
export var commentPrompt = "_i1-9";
export var csatCard = "_i1-0";
export var feedbackSection = "_i1-7";
export var starDisabled = "_i1-6";
export var starEmpty = "_i1-5";
export var starFilled = "_i1-4";
export var starWrapper = "_i1-3";
export var starsContainer = "_i1-2";
export var submittedComment = "_i1-c";
export var thankYouText = "_i1-8";